module.exports = __webpack_public_path__ + "static/media/myself.894a38e3.png";